const INITIAL_STATE = {
    error: false,
    loading: false,
    data: []
}

const Login = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'LOGIN_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'LOGIN_ERROR':
            return { loading: false, error: true, data: action.payload };
        case 'LOGIN_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'LOGIN_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default Login